<template>

  <div class="server" v-if="server.name">

    <redmine-project :project="project"/>

    <h-titles>

      <h1 class="title h2">
        <b-icon icon="terminal-fill"></b-icon>
        {{ server.name }}
      </h1>

      <b-row class="mb-4">
        <b-col>
          <b-card class="h-100">
            <p>{{ server.description }}</p>
            <b-row>
              <b-col cols="3">
                <strong>Infra</strong>
              </b-col>
              <b-col cols="9">
                {{ server.hosting || "Bearstech" }}
              </b-col>
            </b-row>
            <b-row v-if="server.model">
              <b-col cols="3">
                <strong>Type</strong>
              </b-col>
              <b-col cols="9">
                {{ server.model || "" }}
              </b-col>
            </b-row>
            <b-row v-if="$store.state.user.is_staff && server.container">
              <b-col cols="3">
                <strong>Conteneur</strong>
              </b-col>
              <b-col cols="9">
                {{ server.container }}
              </b-col>
            </b-row>
            <b-row v-if="(server.ip_address && server.ip_address) || false">
              <b-col cols="3">
                <strong>IP publique(s)</strong>
              </b-col>
              <b-col cols="9">
                <span v-for="(ip, i) in server.ip_address" :key="i"><b-badge v-if="isPublicIP(ip)">{{ ip }}&nbsp;</b-badge></span>
              </b-col>
            </b-row>
            <b-row v-if="$store.state.user.is_staff && (server.ip_address && server.ip_address) || false">
              <b-col cols="3">
                <strong>IP privée(s)</strong>
              </b-col>
              <b-col cols="9">
                <span v-for="(ip, i) in server.ip_address" :key="i"><b-badge v-if="isPrivateIP(ip)">{{ ip }}&nbsp;</b-badge></span>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="3">
                <strong>Criticité</strong>
              </b-col>
              <b-col cols="9">
                <b-badge :variant="server.criticity == 'production' ? 'primary' : 'secondary'">
                  {{ server.criticity }}
                </b-badge>
              </b-col>
            </b-row>
            <b-row v-if="$store.state.user.is_staff && server.parsed_ticket">
              <b-col cols="3">
                <strong>Ticket</strong>
              </b-col>
              <b-col cols="9">
                <b-badge
                  v-for="(ticket, t) in server.parsed_ticket" :key="t"
                  variant="light"
                  :title="ticket.url"
                  :href="ticket.url">{{ticket.label}}</b-badge>
              </b-col>
            </b-row>
          </b-card>
        </b-col>

        <b-col>
          <b-card class="h-100">
            <b-row>
              <b-col class="text-center" v-if="server.cpu">
                <div class="h4">
                  <b-icon icon="cpu"></b-icon> CPUs
                </div>
                <div class="host_cpus big">
                  {{ server.cpu }}
                </div>
              </b-col>
              <b-col class="text-center" v-if="server.ram">
                <div class="h4">
                  <svg xmlns="http://www.w3.org/2000/svg" height="26" width="26" viewBox="0 0 60 61"><g id="Page-1" fill="currentColor" fill-rule="evenodd"><g id="037---RAM" fill="currentColor" fill-rule="nonzero"><path id="Shape" d="m15.6455 58.92c-.5225144.0020781-1.0240806-.205269-1.3926-.5757l-7.61-7.6113c-.63501308-.6460083-.75233683-1.6398869-.2852-2.416.42121171-.7442075.29434609-1.6779755-.31015421-2.2828255-.60450031-.6048501-1.53819476-.7322557-2.28264579-.3114745-.77649712.4683058-1.77162213.3509684-2.4179-.2851l-.7715-.771c-.7663652-.7689157-.76681226-2.0127336-.001-2.7822l40.3532-40.3532c.7689076-.76686898 2.0133924-.76686898 2.7823 0l.7724.7725c.6352621.64687058.7517949 1.64184394.2832 2.418-.4194718.74445682-.291505 1.67720497.3129633 2.28118399s1.5373198.73119054 2.2814367.31111601c.7767885-.46695415 1.7710244-.34972157 2.4179.2851l7.61 7.6113c.7673106.7690817.7668632 2.0142699-.001 2.7828l-40.3508 40.352c-.3679645.3699285-.8688335.5769611-1.3906.5748zm-10.9199-15.4342c1.02620102-.0001433 2.010312.4079212 2.7353 1.1342 1.23944414 1.2426418 1.49900854 3.1589124.6348 4.6865l7.5723 7.6246 40.3066-40.353-7.6113-7.5654c-1.5184331.89885352-3.4530809.65360545-4.6992-.5957-1.2389172-1.2424584-1.4988311-3.15792333-.6358-4.6856l-.7324-.7861-40.3066 40.353.7724.7256c.59453569-.3522313 1.27285763-.5380885 1.9639-.5381z"/><path id="Shape" d="m20.4326 60.9722c-.5221858.0018999-1.0233753-.2054405-1.3916-.5757l-2.7353-2.7354c-.2599566-.2510745-.3642126-.6228779-.2726972-.9725073.0915155-.3496295.3645604-.6226744.7141899-.7141899.3496294-.0915154.7214328.0127406.9725073.2726972l2.7364 2.7358 8.8447-8.8911-2.7354-2.69c-.380397-.3921753-.3756228-1.01706.0107219-1.4033774.3863446-.3863173 1.0112297-.3910473 1.4033781-.0106226l2.7353 2.7353c.766869.7689076.766869 2.0133924 0 2.7823l-8.8916 8.8916c-.3678984.3700753-.8687756.5772553-1.3906.5752z"/><path id="Shape" d="m35.48 45.9253c-.5221858.0018999-1.0233753-.2054405-1.3916-.5757l-2.7354-2.7353c-.3777934-.3924746-.3719371-1.015136.0131714-1.4004352.3851086-.3852993 1.007767-.3914639 1.4004286-.0138648l2.7363 2.7358 22.5235-22.57-2.7354-2.6895c-.3820936-.3919029-.3781252-1.0181666.0089041-1.4051959s1.013293-.3909977 1.4051959-.0089041l2.7349 2.7358c.7672831.7690769.7668804 2.0142195-.0009 2.7828l-22.5691 22.5692c-.3677355.3699636-.8683689.5771682-1.39.5753z"/><path id="Shape" d="m23.8525 57.9541c-.2652627.0002851-.519701-.105161-.707-.293l-3.42-3.4194c-.3804247-.3921484-.3756947-1.0170335.0106226-1.4033781.3863174-.3863447 1.0112021-.3911189 1.4033774-.0107219l3.42 3.42c.2859208.2860071.3714284.7160737.2166588 1.0897007-.1547695.3736271-.5193447.6172534-.9237588.6172993z"/><path id="Shape" d="m27.2725 54.5347c-.2652974.0003117-.5197765-.1051364-.7071-.293l-3.42-3.42c-.3904653-.390631-.3903309-1.0238347.0003-1.4143.390631-.3904653 1.0238347-.390331 1.4143.0003l3.42 3.42c.2859794.2859849.3715389.7160737.2167859 1.0897354s-.5193461.6173187-.9237859.6173646z"/><path id="Shape" d="m38.8994 42.9072c-.2652527.0003337-.5196971-.105079-.707-.2929l-3.42-3.4195c-.3789722-.3923789-.3735524-1.0160848.0121814-1.4018186s1.0094397-.3911536 1.4018186-.0121814l3.42 3.4194c.2859079.2859943.3714219.7160366.216678 1.0896546-.1547439.3736179-.5192821.6172591-.923678.6173454z"/><path id="Shape" d="m42.3193 39.4878c-.2652627.0002851-.519701-.105161-.707-.293l-3.42-3.42c-.3804247-.3921484-.3756947-1.0170335.0106226-1.4033781.3863174-.3863447 1.0112021-.3911189 1.4033774-.0107219l3.42 3.42c.2859208.2860071.3714284.7160737.2166588 1.0897007-.1547695.3736271-.5193447.6172534-.9237588.6172993z"/><path id="Shape" d="m45.7393 36.0679c-.2652974.0003117-.5197765-.1051364-.7071-.293l-3.42-3.4194c-.3820936-.3919029-.3781252-1.0181666.0089041-1.4051959s1.013293-.3909977 1.4051959-.0089041l3.42 3.4194c.2859794.2859849.3715389.7160737.2167859 1.0897354s-.5193461.6173187-.9237859.6173646z"/><path id="Shape" d="m49.1582 32.6484c-.2652549.0003448-.5197034-.1050696-.707-.2929l-3.419-3.42c-.2590307-.2512868-.3625694-.6226481-.2709202-.9717074s.3642662-.621657.713332-.7132815c.3490657-.0916245.7204198.0119404.9716882.2709889l3.4189 3.42c.2859079.2859943.3714219.7160366.216678 1.0896546-.1547439.3736179-.5192821.6172591-.923678.6173454z"/><path id="Shape" d="m52.5781 29.2285c-.2652737.0003404-.5197324-.1051141-.707-.293l-3.42-3.42c-.2599566-.2510745-.3642126-.6228779-.2726972-.9725073.0915155-.3496295.3645604-.6226744.7141899-.7141899.3496294-.0915154.7214328.0127406.9725073.2726972l3.42 3.42c.2859208.2860071.3714284.7160737.2166588 1.0897007-.1547695.3736271-.5193447.6172534-.9237588.6172993z"/><path id="Shape" d="m55.998 25.8086c-.2652627.0002851-.519701-.105161-.707-.293l-3.42-3.4194c-.3820936-.3919029-.3781252-1.0181666.0089041-1.4051959s1.013293-.3909977 1.4051959-.0089041l3.42 3.42c.2859208.2860071.3714284.7160737.2166588 1.0897007-.1547695.3736271-.5193447.6172534-.9237588.6172993z"/><path id="Shape" d="m17.0127 50.7c-.5304359.0009613-1.0393696-.2095799-1.4141-.585l-6.7929-6.7932c-.78028121-.7814338-.78028121-2.0471662 0-2.8286l4.7412-4.7412c.7812395-.7802789 2.0468605-.7802789 2.8281 0l6.793 6.7929c.7802261.7814566.7802261 2.0471434 0 2.8286l-4.7412 4.7412c-.3746811.3755302-.8836209.5861818-1.4141.5853zm-2.0518-13.534-4.7409 4.7412 6.793 6.7935 4.7422-4.7422z"/><path id="Shape" d="m25.9043 41.8081c-.5302244.0008839-1.0390116-.2092369-1.4141-.584l-6.7929-6.7941c-.7802789-.7812395-.7802789-2.0468605 0-2.8281l4.7412-4.7413c.7812623-.7802238 2.0468377-.7802238 2.8281 0l6.793 6.793c.3751443.3749684.5859129.8836402.5859129 1.41405s-.2107686 1.0390816-.5859129 1.41405l-4.7412 4.7417c-.3748736.3751695-.8837401.5855749-1.4141.5847zm-2.0518-13.5332-4.7412 4.7412 6.793 6.7935 4.7412-4.7417v-.0005l.001-.001z"/><path id="Shape" d="m34.7959 32.917c-.5304359.0009613-1.0393696-.2095799-1.4141-.585l-6.7939-6.7929c-.7780933-.7818258-.7785402-2.0453241-.001-2.8277l4.7431-4.7422c.3734499-.3762183.8820026-.5872239 1.4121-.5859h.0019c.5307085-.0014456 1.0399276.2095377 1.4141.5859l6.793 6.7935c.3751443.3749684.5859129.8836402.5859129 1.41405s-.2107686 1.0390816-.5859129 1.41405l-4.7411 4.7412c-.3747304.3754201-.8836641.5859613-1.4141.585zm-2.0518-13.5337-4.7421 4.7412 6.7939 6.7935 4.7422-4.7422z"/><path id="Shape" d="m43.6865 24.0254c-.5301614.0007141-1.0388551-.2093829-1.414-.584l-6.7925-6.7939c-.7802904-.7812738-.7802904-2.0469262 0-2.8282l4.7412-4.7412c.3741724-.37636233.8833915-.58734561 1.4141-.5859h.0019c.5305731-.00124892 1.0395271.21013394 1.4131.5869l6.793 6.792c.3751443.3749684.5859129.8836402.5859129 1.41405s-.2107686 1.0390816-.5859129 1.41405l-4.7412 4.7417c-.375311.3754088-.8847624.5857608-1.4156.5845zm-2.0517-13.5332-4.7412 4.7412 6.7929 6.7935 4.7422-4.7417.001-.001z"/></g></g></svg>
                  RAM
                </div>
                <div class="host_ram big">
                  {{ server.ram }}
                </div>
              </b-col>
              <b-col class="text-center" v-if="server.disk">
                <div class="h4">
                  <b-icon icon="hdd"></b-icon> Disque
                </div>
                <div class="host_disk big">
                  {{ server.disk }}
                </div>
              </b-col>
            </b-row>
            <b-row class="mt-4" v-if="server.disk_add">
              <b-col class="">
                <div class="h5">
                  <b-icon icon="hdd"></b-icon> Disques additionnels
                </div>
              </b-col>
              <b-col>
                <div v-if="(server.disk_add && server.disk_add.length) || false">
                  <div class="font-weight-bold" v-for="(disk,d) in server.disk_add" :key="d">
                    {{ disk }}
                  </div>
                </div>
                <div v-else class="font-weight-bold">
                  Aucun
                </div>
              </b-col>
            </b-row>
            <b-row class="mt-4" v-if="server.disk_add">
              <b-col class="">
                <div class="h5">
                  <b-icon icon="hdd"></b-icon> Filers
                </div>
              </b-col>
              <b-col>
                <div v-if="(server.filers && server.filers.length) || false">
                  <div class="font-weight-bold" v-for="(filer,f) in server.filers" :key="f">
                    {{ filer.size }}
                  </div>
                </div>
                <div v-else class="font-weight-bold">
                  Aucun
                </div>
              </b-col>
            </b-row>

            <!-- uptime -->
            <b-row class="mt-4" v-if="server.uptime">
              <b-col class="">
                <div class="h5">
                  <b-icon icon="thermometer"></b-icon> Disponibilité mensuelle<br/><span class="small mx-5">(30 derniers jours)</span>
                </div>
              </b-col>
              <b-col>
                <div class="font-weight-bold">
                  {{ server.uptime }}%
                </div>
              </b-col>
            </b-row>

          </b-card>
        </b-col>
      </b-row>




      <b-card class="mb-4" v-if="(server.packages && server.packages.length) || (server.debian && server.kernel) || false">
        <b-card-title>
          <h-title
            label="OS et Paquets installés"
            short_label="OS & Paquets"
            uid="packages"
            :isCardTitle="true"
            icon="box-seam"
            ></h-title> <!-- packages -->
        </b-card-title>

        <div v-if="server.debian.needs_upgrade" class="bg-danger px-2 py-1 text-white">
          Il est important d'organiser la mise à jour de votre OS. Veuillez nous <button-support-ticket
            :identifier="project.identifier"
            :subject="'Mise à jour OS serveur ' + server.name"
            :body="'L\'OS du serveur ' + this.server.name + ' est obsolète.\n\nPouvons nous planifier une mise à jour ?'"
            :isLink="true"
            css="text-white text-decoration-underline"
          >contacter ici</button-support-ticket>.
        </div>

        <b-row class="bordered-bottom" v-if="server.debian && server.kernel">
          <b-col class="mt-3 mb-0">
            <b-row>
              <b-col cols="2">
                Debian
              </b-col>
              <b-col cols="10">
                <b-badge variant="light">{{ server.debian.version }}</b-badge>
                <b-badge v-if="server.debian.eolLts" :variant="server.debian.state">
                  <span>(EoL LTS {{server.debian.eolLts}})</span>
                </b-badge>
                <button-support-ticket
                  class="ml-2"
                  :identifier="project.identifier"
                  :subject="'Mise à jour OS serveur ' + server.name"
                  :body="'L\'OS du serveur ' + this.server.name + ' est obsolète.\n\nPouvons nous planifier une mise à jour ?'"
                  :isBadge="true"
                  v-if="server.debian.needs_upgrade"
                >Cliquer ici pour mettre à jour</button-support-ticket>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="2">
                GNU/Linux kernel
              </b-col>
              <b-col cols="10"><b-badge variant="light">{{ server.kernel }}</b-badge></b-col>
            </b-row>
          </b-col>
        </b-row>

        <template v-for="(pkg, p) in server.packages">
        <b-row
          :title="pkg.name + ' ' + pkg.version"
          v-if="pkg.name !== 'tsirko' && pkg.version.indexOf('{') === -1"
          :key="p"
          >
          <b-col>
            <b-row>
              <b-col cols="2">
                {{pkg.name}}
              </b-col>
              <b-col cols="10">
                <b-badge variant="light">
                  {{pkg.version}}
                </b-badge>
              </b-col>
            </b-row>
            <b-row v-if="pkg.extra">
              <b-badge
                 :href="pkg.url || ''">{{pkg.extra}}</b-badge>
            </b-row>
          </b-col>
        </b-row>
        </template>
      </b-card>

      <b-card class="mb-4" no-body v-if="(server.upgrades && server.upgrades.length) || false">
        <b-card-body>
          <b-card-title>
            <h-title
              label="Mise à jour de paquets (90 derniers jours)"
              short_label="Mise à jour"
              uid="upgrades"
              :isCardTitle="true"
              icon="arrow-clockwise"></h-title> <!-- upgrades -->
          </b-card-title>
        </b-card-body>
        <table class="table table-hover">
          <tr>
            <th>Date</th>
            <th>Packages</th>
          </tr>
          <tr v-for="(upgrade, u) in server.upgrades" :key="u">
            <td style="word-break: keep-all;">{{upgrade.day}}</td>
            <td>
              <b-badge
                v-for="(pkg, p) in upgrade.upgrades" :key="p"
                :variant="pkg.name == 'gitlab' ? 'gitlab-orange' : 'light'"
                :title="pkg.tooltip"
                >
                <span v-if="pkg.name == 'gitlab'">
                  <svg fill="#000000" width="800px" height="800px" viewBox="-2 -2.5 24 24" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMinYMin" class="badge-logo-white"><path d='M10.006 18.443L6.326 7.118h7.36l-3.68 11.325zm0 0L1.168 7.118h5.158l3.68 11.325zM1.168 7.118l8.838 11.325-9.68-7.032a.762.762 0 0 1-.276-.852l1.118-3.441zm0 0L3.385.296a.38.38 0 0 1 .724 0l2.217 6.822H1.168zm8.838 11.325l3.68-11.325h5.157l-8.837 11.325zm8.837-11.325l1.119 3.441a.762.762 0 0 1-.277.852l-9.68 7.032 8.838-11.325zm0 0h-5.157L15.902.296a.38.38 0 0 1 .725 0l2.216 6.822z' /></svg>
                </span>
                {{ pkg.name }}
              </b-badge>
              <b-badge
                v-for="(cve, c) in upgrade.cves" :key="c"
                variant="success"
                :title="cve.description"
                >{{ cve.id }}</b-badge>
            </td>
          </tr>
        </table>
      </b-card>

      <b-card class="mb-4" no-body v-if="(server.docker_containers && server.docker_containers.length) || false">
        <b-card-body>
          <b-card-title>
            <h-title
              label="Conteneurs Docker"
              short_label="Conteneurs"
              uid="docker"
              :isCardTitle="true"
              icon="hdd-network"
              ></h-title>
          </b-card-title>
        </b-card-body>
        <b-table
          :fields="['project', 'name', 'Image', 'Status', 'FROM']"
          :items="server.docker_containers"
          responsive
          hover
          >
         <template v-slot:cell(project)="data">
           <div v-if="!data.item.git_url">
             {{data.value}}
           </div>
           <a v-if="data.item.git_url" :href="data.item.git_url">
             {{data.value}}
           </a>
         </template>

         <template v-slot:cell(image)="data">
           <div :title="'Commande: ' + data.item.Command">{{ data.item.tags.join() }}</div>
         </template>

         <template v-slot:cell(from)="data">
           <b-badge v-if="data.value.version && data.value.current_version"
                :variant="data.value.level"
                :title="data.value.level == 'success' ? '' : ('Vous devriez re-déployer votre projet. Une nouvelle version de cette image est disponible au ' + data.value.current_date)"
             >{{ data.value.repository }}</b-badge>
           <b-badge v-if="data.value.version && !data.value.current_version"
                :variant="data.value.level"
                title="Aucune information sur la version actuelle."
             >{{ data.value.repository }}</b-badge>
           <b-badge v-if="!data.value.version && !data.value.current_version"
                :variant="data.value.level"
                title="Cette image n'est probablement pas basée sur une image Bearstech"
                >Version inconnue</b-badge>
         </template>

        </b-table>
        <p class="pl-2 pr-2">
          <span style="color:#28a745; font-weight: bold;">vert</span> : l’image de l'application bénéficie des correctifs de sécurité système les plus récents<br/>
          <span style="color:#ffc107; font-weight: bold;">jaune</span> : le statut de l’image ne peut être analysé car vous avez utilisé une image non garantie ou qui n'est plus maintenue<br/>
          <span style="color:#dc3545; font-weight: bold;">rouge</span> : l’image de l’application doit être rebuildée et redéployée, car elle n'est pas à jour
        </p>
	<p class="ml-2 mb-0"><b-icon icon="info-circle" /> Afin de recevoir une alerte lors de la publication de mises à jour de sécurité pour les images Docker maintenues par Bearstech, rendez-vous sur <a href="https://support.bearstech.com/projects/documentation/wiki/Docker_Changelog">https://support.bearstech.com/projects/documentation/wiki/Docker_Changelog</a> et abonnez-vous aux notifications (bouton "surveiller")<p/>
      </b-card> <!-- docker containers -->

      <b-card class="mb-4" no-body v-if="(server.sshd && server.sshd.connections && server.sshd.connections.length) || false">
        <b-card-body>
          <b-card-title>
            <h-title
              label="Connexions SSH"
              short_label="Connexions"
              uid="sshd_connections"
              :isCardTitle="true"
              icon="arrow-down-up"
              ></h-title>
          </b-card-title>
        </b-card-body>
        <ssh-connections :connections="server.sshd.connections" />
      </b-card> <!-- docker containers -->

      <common-server-tables :context="server" :alerts="alerts" />

      <b-card class="mb-4">
        <b-card-title>
          <h-title label="Monitoring" uid="metrics" :isCardTitle="true" icon="graph-up"></h-title>
        </b-card-title>
        <graphs :hostname="server.name" />
      </b-card>

      <mails-datas :hostname="server.name" />


    </h-titles>
  </div> <!-- server.name -->
</template>

<script>
import RedmineProject from './misc/RedmineProject.vue'
import HTitles from './misc/HTitles.vue'
import HTitle from './misc/HTitle.vue'
import MailsDatas from './misc/MailsDatas.vue'
import Graphs from './misc/Graphs.vue'
import CommonServerTables from './tables/CommonServerTables.vue'
import SshConnections from './tables/SshConnections.vue'
import ButtonSupportTicket from './misc/ButtonSupportTicket.vue'

export default {
  name: 'Server',
  components: {
    RedmineProject,
    HTitles,
    HTitle,
    MailsDatas,
    Graphs,
    CommonServerTables,
    SshConnections,
    ButtonSupportTicket,
  },
  data () {
    this.$store.commit('setLoading', true)
    return {
      period: "day",
      project: {},
      server: {"name": null},
      alerts: {},
      debianVersionReminder: '',
      debianEoLLTS: '',
    }
  },
  computed: {
  },

  methods: {
    getGrahUrl (panel_id) {
      return `/grafana/${this.server.graphs.hostname}/${panel_id}/${this.period}/graph.png`
    },
    getServer () {
      if (this.server.name === this.$route.params.server_id) {
        return
      }
      this.server = {}
      this.$store.commit('setLoading', true)
      this.$http.get(document.location.pathname.slice(1).replace(/\/$/, ''))
        .then((result) => {
          console.log(result)
          this.server = result.data.host
          this.project = result.data.project
          if (typeof(Storage) !== "undefined" && this.project && this.project.name) {
            localStorage[`${this.project.identifier}#name`] = this.project.name
            this.$store.commit('setTitle', this.project.name)
          }
          this.alerts = result.data.alerts
          if (!this.$route.params.project_id) {
            this.$store.commit("setTitle", this.server.name)
          }

          this.$store.commit('setLoading', false)
        })
        .catch((error) => {
            this.$store.commit('setLoading', false)
            this.$bvModal.msgBoxOk("" + error)
              .then(() => {
                  window.location.href = "/"
               })
            throw error
        })
    },
    isPublicIP (ip) {
      return !ip.startsWith('10.') && !ip.startsWith('172.') && !ip.startsWith('192.')
    },
    isPrivateIP (ip) {
      return ip.startsWith('10.') || ip.startsWith('172.') || ip.startsWith('192.')
    },
  },
  watch: {
    $route: 'getServer',
  },
  mounted () {
    this.getServer()
  }
}
</script>

<style lang="scss">
  .small-padding {
    padding: 0 0.3rem;
  }
  section.packages > .btn-group,
  .badge
  {
    margin: 0.2em 0.3em;
  }
  .metrics-content {
    min-height: 2928px;
  }
  #packages .badge,
  #upgrades .badge {
    text-transform: none;
  }
</style>
